import axios from 'axios';
import { ApiException } from '../../types';

export function isMissingBigQueryTableError(error: unknown): boolean {
  if (axios.isAxiosError(error)) {
    const exceptionType = error.response?.data.exceptionType;
    return exceptionType === 'BigQueryException';
  }

  return false;
}

export function isEntityAlreadyExistsError(error: unknown): boolean {
  if (axios.isAxiosError(error)) {
    const errorResponse = error.response?.data as ApiException | undefined;
    return !!errorResponse?.message?.includes('Entity already exists');
  }

  return false;
}
